import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../modules/biodieselFormula';
import { bindActionCreators } from 'redux';

// XXX memoize
const mapStateToProps = state => {

	/** @namespace state.lists.biodieselFormulaIds **/
	/** @namespace state.maps.biodieselFormula */
	let biodieselFormulas = [];
	if (state.lists.biodieselFormulaIds) {
		biodieselFormulas = _.map(state.lists.biodieselFormulaIds, id => state.maps.biodieselFormula[id]);
	}

	return {
		biodieselFormulas,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	searchBiodieselFormulas : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
